import React from 'react';
import { motion } from 'framer-motion';
import { BriefcaseBusinessIcon, BrainIcon, HeartHandshakeIcon, MessageCircleMoreIcon, SproutIcon, TargetIcon } from 'lucide-react';
const tools = [{
  icon: BrainIcon,
  title: 'Bienestar emocional'
}, {
  icon: HeartHandshakeIcon,
  title: 'Relaciones saludables'
}, {
  icon: SproutIcon,
  title: 'Desarrollo personal'
}, {
  icon: BriefcaseBusinessIcon,
  title: 'Crecimiento profesional'
}, {
  icon: MessageCircleMoreIcon,
  title: 'Comunicación asertiva'
}, {
  icon: TargetIcon,
  title: 'Construcción de hábitos'
}];
export function InsideLook() {
  return <section className="bg-sage/45 px-4 py-20 md:py-28" data-id="element-140" data-mp="2h8vta79p5kil">
      <div className="mx-auto max-w-6xl" data-id="element-141" data-mp="2h69lc6iw92zu">
        <div className="mx-auto max-w-2xl text-center" data-id="element-142" data-mp="2m6dqj0ecqbar">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-clay-dark" data-id="element-143" data-mp="2m4ua99sp408z">Herramientas para tu vida cotidiana</p>
          <h2 className="mt-3 font-heading text-4xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-144" data-mp="3en830uz6cw17">
            Incorporá recursos para lo que hoy te importa
          </h2>
          <p className="mt-5 text-base leading-7 text-ink/65" data-id="element-145" data-mp="21tj4jhwukmi8">
            Llevá el aprendizaje más allá de la lectura con herramientas aplicables a distintos aspectos de tu vida.
          </p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-146" data-mp="26uyunodvtj7h">
          {tools.map(({
          icon: Icon,
          title
        }, index) => <motion.article key={title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          delay: index * 0.06
        }} className="flex min-h-36 flex-col justify-between rounded-2xl border border-ink/10 bg-paper p-6" data-id="element-147" data-mp="2liju98bjt0an" data-mpi={index}>
              <Icon className="h-6 w-6 text-clay-dark" aria-hidden="true" data-id="element-148" data-mp="1071x3481sjv8" />
              <h3 className="mt-8 font-heading text-2xl font-semibold text-ink" data-id="element-149" data-mp="v8iar2pjl62c">{title}</h3>
            </motion.article>)}
        </div>
      </div>
    </section>;
}